<template>
  <div>
    <section class="uk-margin">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link to="/admin">Администрирование</router-link>
          </li>
          <li class="is-active">
            <a href="#">Заказы</a>
          </li>
          <li>
            <a href="#" @click.prevent="add()">Добавить</a>
          </li>
        </ul>
      </nav>
    </section>
    <section class="uk-margin">
      <b-pagination
        :total="total"
        :current="currentPage"
        :simple="false"
        :per-page="filters.limit"
        :paginated="false"
        :pagination-simple="true"
        order="is-right"
        @change="pageChange">
      </b-pagination>
    </section>
    <section class="uk-margin">
      <b-field grouped group-multiline>
        <b-field label="Сортировка">
          <b-select v-model="filters.order" @input="pageChange()">
            <option value="asc">Восходящая (ASC)</option>
            <option value="desc">Нисходящая (DESC)</option>
          </b-select>
        </b-field>
        <b-field label="На страницу">
          <b-select v-model="filters.limit" @input="pageChange()">
            <option
              v-for="option in limits"
              :value="option"
              :key="option">
              {{ option }} шт.
            </option>
          </b-select>
        </b-field>
        <b-field label="Состояние">
          <b-field>
            <b-select v-model="filters.state_id" placeholder="Filter by State" @input="pageChange()">
              <option
                v-for="option in states"
                :value="option.id"
                :key="option.id">
                {{ option.name }}
              </option>
            </b-select>
            <p class="control">
              <button class="button is-danger" @click="clearState()">X</button>
            </p>
          </b-field>
        </b-field>
      </b-field>
    </section>
    <section class="uk-margin">
      <b-table class="app-table"
        :bordered="true"
        :hoverable="true"
        :data="data"
        :default-sort-direction="filters.order"
        :show-detail-icon="true"
        detailed
        detail-key="id">
        <template slot-scope="props" @click="click">
          <b-table-column field="id" label="ID" width="40" sortable numeric>
            {{ props.row.id }}
          </b-table-column>
          
          <b-table-column field="date" label="Дата заказа" sortable>
            <!-- {{ props.row.date }} -->
            {{ moment(props.row.date).add(moment().utcOffset(), 'minute').format('YYYY-MM-DD HH:ss:mm') }}
          </b-table-column>

          <b-table-column field="client_name" label="Имя клиента" sortable>
            {{ props.row.client_name }}
          </b-table-column>

          <b-table-column field="client_email" label="Email" sortable>
            {{ props.row.client_email }}
          </b-table-column>

          <b-table-column field="client_phone" label="Телефон" sortable>
            {{ props.row.client_phone }}
          </b-table-column>

          <b-table-column field="client_id" label="Клиент" sortable>
            <b-tag type="is-dark">
              <a href="#" class="app-order-client" @click="showClient(props.row.client_id)" v-if="props.row.client_id">
                {{ props.row.client_name }}
              </a>
              <template v-else="">
                {{ props.row.client_name }}
              </template>
            </b-tag>
          </b-table-column>
          
          <b-table-column field="manager_id" label="Менеджер" sortable>
            <template v-if="props.row.manager_id">
              <b-tag type="is-primary">
                <a href="#" class="app-order-manager">
                  {{ humanManager(props.row.manager_id) }}
                </a>
              </b-tag>
            </template>
          </b-table-column>

          <b-table-column field="charts" label="Количество ЭНК">
            ( {{props.row.charts.length}} )
          </b-table-column>

          <b-table-column field="state_id" label="Состояние" sortable>
            <a href="#">
              <b-tag type="is-dark">{{ humanState(props.row.state_id) }}</b-tag>
            </a>
          </b-table-column>
          
          <b-table-column label="Действие" centered>
            <div class="block">
              <a href="#" @click="editRow(props.row.id)" style="margin-right: .35rem;">
                <b-icon icon="pen" type="is-dark" size="is-small"></b-icon>
              </a>
              <a href="#" @click="dropRow(props.row.id)">
                <b-icon icon="trash" type="is-danger" size="is-small"></b-icon>
              </a>
            </div>
          </b-table-column>

      </template>
      
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon
                icon="sad-tear"
                size="is-large">
              </b-icon>
            </p>
            <p>Данных нет.</p>
          </div>
        </section>
      </template>

      <template slot="detail" slot-scope="props">
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-48x48">
                <img src="https://bulma.io/images/placeholders/96x96.png" alt="Placeholder image">
              </figure>
            </div>
            <div class="media-content">
              <p class="title is-4">{{ props.row.client_name }}</p>
              <p class="subtitle is-6">{{ props.row.client_email }}</p>
            </div>
          </div>

          <div class="content">
            {{ props.row.message }}
            <br>
            <time :datetime="moment(props.row.date).add(moment().utcOffset(), 'minute').format('YYYY-MM-DD')"><strong>{{ moment(props.row.date).add(moment().utcOffset(), 'minute').format('YYYY-MM-DD HH:ss:mm') }}</strong></time> #{{ moment(props.row.date).add(moment().utcOffset(), 'minute').fromNow()}}
            <br><br>
            <b-field grouped group-multiline>
              <template v-for="item in props.row.charts">
                <div v-bind:key="item.id" class="control">
                  <b-tag type="is-primary" >{{item.name}}</b-tag>
                </div>
              </template>
            </b-field>
          </div>
        </div>
      </template>

      </b-table>
    </section>
    <section class="uk-margin">
      <b-pagination
        :total="total"
        :current="currentPage"
        :simple="false"
        :per-page="filters.limit"
        :paginated="false"
        :pagination-simple="true"
        order="is-right"
        @change="pageChange">
      </b-pagination>
    </section>
  </div>
</template>

<script>
import { EventBus } from '@/utils'
export default {
  name: "OrderTable",
  data() {
    const data = []
    const limits = [
      5, 10, 20, 25, 50, 75, 100
    ]
    const d_states = [
      {
        id: null,
        name: "Новый"
      }
    ]
    const managers = []
    return {
      data: data,
      states: d_states,
      managers: managers,
      limits: limits,
      currentPage: 1,
      total: 0,
      filters: {
        state_id: null,
        order: 'asc',
        limit: 25
      }
    }
  },
  mounted: function() {
    this.$store.dispatch('getOrders')
      .then(response => {
        let data = response.data;
        this.total = data.total
        data.data.forEach((item) => {
          this.data.push(item)
        })
      })
      .catch(error => {
        this.data = []
      })

    this.$store.dispatch('getUsers')
      .then(response => {
        let data = response.data.data;
        data.forEach((item) => {
          this.managers.push(item)
        })
      })
      .catch(error => {
        this.managers = []
      })

    this.$store.dispatch('getStates')
      .then(response => {
        let data = response.data.data;
        this.states = []

        data.forEach((item) => {
          this.states.push(item)
        })
        
      })
      .catch(error => {
        this.states = d_states
      })
    
    EventBus.$on('successCreateOrder', (data) => {
      this.data.push(data)
    })

    EventBus.$on('failedCreateOrder', (msg) => {
      this.$toast.open({
        message: `${this.$i18n.t('admin.create_error')} ${msg}`,
        type: 'is-danger',
        position: 'is-bottom'
      })
    })
    
    EventBus.$on('successUpdateOrder', () => {
      this.pageChange()
    })

  },
  beforeDestroy: function(){
    EventBus.$off('successCreateOrder')
    EventBus.$off('failedCreateOrder')
    EventBus.$off('successUpdateOrder')
  },
  methods: {
    add(item){
      EventBus.$emit("showModal", "order.add", null)
    },
    showClient(id){
      EventBus.$emit("showModal", "client.edit", id)
    },
    editRow(item){
      EventBus.$emit("showModal", "order.edit", item)
    },
    dropRow(id) {
      let $this = this
      this.$dialog.confirm({
        message: $this.$i18n.t('admin.order_delete_message'),
        cancelText: $this.$i18n.t('admin.no'),
        confirmText: $this.$i18n.t('admin.yes'),
        onConfirm: () => {
          
          $this.$store.dispatch('deleteOrder', id).then(
            $this.pageChange()
          )
          

        }
      })
    },
    humanState: function(current_state){
      let name = this.states.filter(function(state) {
        return state.id === current_state;
      })
      .map(function(state) {
        return state.name;
      }); 
      if (name.length){
        return name[0]
      }
      else{
        return ""
      }
    },
    humanManager: function(current_state){
      let name = this.managers.filter(function(state) {
        return state.id === current_state;
      })
      .map(function(state) {
        return state.username;
      }); 
      if (name.length){
        return name[0]
      }
      else{
        return ""
      }
    },
    clearState(){
      this.filters.state_id = null
      this.pageChange()
    },
    pageChange(page){
      if(page){
        this.currentPage = page
      }
     
      this.$store.dispatch('getPageOrders', { page: this.currentPage, filters: this.filters })
        .then(response => {
          let data = response.data;
          
          this.data = []
          this.total = data.total
          data.data.forEach((item) => {
            this.data.push(item)
          })

        })
        .catch(error => {
          this.data = []
        })
    }
  }
}
</script>

<style scoped>
a.app-order-client, a.app-order-manager {
  color: white;
}
</style>